import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["href"]
const _hoisted_2 = {
  type: "button",
  class: "bg-green-700 hover:bg-green-600 rounded shadow-[0_0_4px_0px_rgb(17,24,39,0.25)] p-[6px] border border-transparent mx-1 flex items-center focus:outline-none focus:ring-1 focus:ring-offset-1 focus:ring-green-600"
}

import LinkIcon from "@/components/icons/linkIcon.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'LinkButton',
  props: {
    routeLink: {
        type: String,
        required: true,
    },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("a", { href: __props.routeLink }, [
    _createElementVNode("button", _hoisted_2, [
      _createVNode(LinkIcon, { class: "object-contain w-5 h-5" }),
      _renderSlot(_ctx.$slots, "default")
    ])
  ], 8, _hoisted_1))
}
}

})